import { createModel, RematchDispatch } from '@rematch/core';
import baseEntity from './base.entity';
import { RootModel } from '../models';
import { PaginationType } from '../../types/CommonTypes';
import { TourBgSoundData, TourGuideData } from '../../types/TourSoundData';
import * as TourGuideService from '../../services/tourGuide.service';

export const storeName = 'tourGuideEntity';

export const tourGuideEntity: any = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: RematchDispatch<typeof tourGuideEntity>) => ({
    async load(params): Promise<{ content?: TourGuideData[] } & PaginationType> {
      const res = await TourGuideService.getTourGuides({ params });
      const { content } = res.data;
      if (content && content.length) {
        this.saves(content);
      }
      return res.data;
    },
    async loadBgSound(params): Promise<{ content?: TourBgSoundData[] } & PaginationType> {
      const res = await TourGuideService.getTourBgSounds({ params });
      const { content } = res.data;
      if (content && content.length) {
        this.saves(content);
      }
      return res.data;
    },
  }),
});

export default tourGuideEntity;
